import React from "react";
import { useTranslation } from "react-i18next";


const HeroSection = () => {
  const { t } = useTranslation("career"); // Hook to use translations

  return (
    <div className="relative py-28 md:pt-[140px] px-5 sm:px-10 xl:pl-[140px] md:pb-[387px]">
      {/* Video Background */}
      <video
        src="/assets/Video/career1.mp4"

        autoPlay
        loop
        muted
        className="absolute top-0 left-0 w-full h-full object-cover"
      >

      </video>
      <div className="absolute inset-0 bg-[#00000099]"></div>

      {/* Content */}
      <div className="relative z-10 flex flex-col justify-start items-start sm:gap-5 container-class">
        <div className="max-w-[818px]">
          <h1 className="web-heading-main text-2xl md:text-4xl">
            {t("changing_future_of_mining")}
          </h1>
          <p className="text-color body-xl md:text-xl max-w-5xl py-[20px] text-sm">
            {t("company_description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
